import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from 'libs/auth/src/lib/auth.service';

@Component({
  selector: 'dk-no-role-found',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './no-role-found.component.html',
  styleUrls: ['./no-role-found.component.scss'],
})
export class NoRoleFoundComponent {

  constructor(private authService: AuthService) {}

  async logout(): Promise<void> {
    await this.authService.logout();
  }
}



// import { Component } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { RouterModule } from '@angular/router';
// import { AuthService } from 'libs/auth/src/lib/auth.service';
//
// @Component({
//   selector: 'dk-no-role-found',
//   standalone: true,
//   imports: [CommonModule,RouterModule],
//   templateUrl: './no-role-found.component.html',
//   styleUrls: ['./no-role-found.component.scss'],
// })
// export class NoRoleFoundComponent {
//
// constructor(private authService:AuthService){}
//
//   logout(){
//     this.authService.startLogout();
//   }
// }
